"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIllustrationToRender = void 0;
var react_1 = __importDefault(require("react"));
var CreditCart_1 = __importDefault(require("../../illustrations/CreditCart"));
var Documents_1 = __importDefault(require("../../illustrations/Documents"));
var DoneCheck_1 = __importDefault(require("../../illustrations/DoneCheck"));
var EmptyCart_1 = __importDefault(require("../../illustrations/EmptyCart"));
var EmptyInbox_1 = __importDefault(require("../../illustrations/EmptyInbox"));
var Error_1 = __importDefault(require("../../illustrations/Error"));
var Images_1 = __importDefault(require("../../illustrations/Images"));
var Location_1 = __importDefault(require("../../illustrations/Location"));
var Messages_1 = __importDefault(require("../../illustrations/Messages"));
var NoConection_1 = __importDefault(require("../../illustrations/NoConection"));
var NoSearchResults_1 = __importDefault(require("../../illustrations/NoSearchResults"));
var NoTasks_1 = __importDefault(require("../../illustrations/NoTasks"));
var Users_1 = __importDefault(require("../../illustrations/Users"));
function getIllustrationToRender(illustrationKey, illustrationConfigs) {
    switch (illustrationKey) {
        case "creditCard":
            return react_1.default.createElement(CreditCart_1.default, __assign({}, illustrationConfigs));
        case "documents":
            return react_1.default.createElement(Documents_1.default, __assign({}, illustrationConfigs));
        case "doneCheck":
            return react_1.default.createElement(DoneCheck_1.default, __assign({}, illustrationConfigs));
        case "emptyCart":
            return react_1.default.createElement(EmptyCart_1.default, __assign({}, illustrationConfigs));
        case "emptyInbox":
            return react_1.default.createElement(EmptyInbox_1.default, __assign({}, illustrationConfigs));
        case "error":
            return react_1.default.createElement(Error_1.default, __assign({}, illustrationConfigs));
        case "images":
            return react_1.default.createElement(Images_1.default, __assign({}, illustrationConfigs));
        case "location":
            return react_1.default.createElement(Location_1.default, __assign({}, illustrationConfigs));
        case "messages":
            return react_1.default.createElement(Messages_1.default, __assign({}, illustrationConfigs));
        case "noConection":
            return react_1.default.createElement(NoConection_1.default, __assign({}, illustrationConfigs));
        case "noSearchResults":
            return react_1.default.createElement(NoSearchResults_1.default, __assign({}, illustrationConfigs));
        case "noTasks":
            return react_1.default.createElement(NoTasks_1.default, __assign({}, illustrationConfigs));
        case "users":
            return react_1.default.createElement(Users_1.default, __assign({}, illustrationConfigs));
        default:
            return react_1.default.createElement("div", null);
    }
}
exports.getIllustrationToRender = getIllustrationToRender;
//# sourceMappingURL=helpers.js.map